import { FontAwesome5 } from '@expo/vector-icons';
import { primaryFontFamily, styled } from '@openeducation/oe-it-themes';
import * as React from 'react';
import { View, FlexStyle, StyleProp } from 'react-native';

import MDText from '../../atoms/md-text/md-text';
import { OEButton } from '../../atoms/oe-button/oe-button';
import type { OEButtonProps } from '../../atoms/oe-button/oe-button';
import { flex, mt, mv, width } from '../../style-utils';
import { EllipseIcon } from '../../templates/ellipse-icon/ellipse-icon';

type FooterButton = Omit<OEButtonProps, 'children'> & {
  label: string;
};

export interface WarnMessageProps {
  styleContainer?: StyleProp<FlexStyle>;
  buttons: FooterButton[];
  roundedIcon?: React.ReactNode;
  title?: string;
  body?: string;
}

const WarnMessage = ({
  styleContainer,
  buttons,
  body,
  roundedIcon,
  title,
}: WarnMessageProps) => {
  return (
    <View
      style={[
        mv(40),
        width(630),
        flex('align-self-center', 'align-items-center'),
        styleContainer,
      ]}
    >
      {roundedIcon && (
        <EllipseIcon iconSize={32}>
          <FontAwesome5 name="check" size={32} />
        </EllipseIcon>
      )}
      {title && (
        <MDText style={mt(14)} fontFamily={primaryFontFamily} size={24}>
          {`**${title}**`}
        </MDText>
      )}
      {body && (
        <MDText style={mt(14)} fontFamily={primaryFontFamily}>
          {body}
        </MDText>
      )}
      <Row>
        {buttons.map(({ label, ...rest }, index) => (
          <OEButton
            key={`${label}-${index}`}
            size="huge"
            style={mt(18)}
            {...rest}
          >
            {label}
          </OEButton>
        ))}
      </Row>
    </View>
  );
};

export default WarnMessage;

const Row = styled.View`
  flex-direction: row;
  width: 80%;
  justify-content: space-around;
`;
